import axios from 'axios';
import { authHeader } from './authservice/auth-header';

const API_URL = process.env.VUE_APP_BASE_API_URL;

class TemplateService {
    getTemplate() {
        return axios.get(API_URL+'template', { headers: authHeader() });
    }
}

export default new TemplateService();
